import styled from "@emotion/styled";
import Dialog, { dialogClasses } from "@mui/material/Dialog";
import { paperClasses } from "@mui/material/Paper";
import { dialogContentClasses, mobileStepperClasses } from "@mui/material";

export const Content = styled.div({
	display: "flex",
	flexDirection: "column",
	height: "100%"
});

interface StyledDialogProps {
	dialogHeight?: number;
}

export const StyledDialog = styled(Dialog, {
	shouldForwardProp: (prop) => prop !== "dialogHeight"
})<StyledDialogProps>(({ theme, dialogHeight = 420 }) => ({
	[`& > .${dialogClasses.container} > .${paperClasses.root}`]: {
		height: dialogHeight,
		minWidth: 600,
		paddingBottom: "16px",
		form: {
			display: "flex",
			flexDirection: "column",
			flex: 1
		},
		h2: {
			paddingBottom: 8
		},
		[`.${dialogContentClasses.root}`]: {
			padding: "16px 24px"
		},
		[`.${mobileStepperClasses.root}`]: {
			padding: "8px 24px"
		},
		[theme.breakpoints.down("md")]: {
			height: dialogHeight + 80,
			minWidth: 375,
			h2: {
				alignItems: "flex-start",
				"button:first-of-type": {
					padding: "4px 0px"
				}
			}
		}
	}
}));
